import BrowserMessageScreen from './BrowserMessageScreen.js';

export default BrowserMessageScreen;
